import { render, staticRenderFns } from "./whitelabels.vue?vue&type=template&id=64a87d48&"
import script from "./whitelabels.vue?vue&type=script&lang=js&"
export * from "./whitelabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports